import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { combineSx, formStyles } from '../ClaimCMS1500Form.styles';
import { ClaimRadioGroup, ClaimTextField } from '../fields';

export const Box25_FederalTaxId: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">25. FEDERAL TAX I.D. NUMBER</Typography>
      <Box display="flex" gap={1} alignItems="center">
        <Controller
          name="federalTaxIdNumber"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              size="small"
              sx={combineSx({ flex: 1 }, formStyles.monospaceField)}
            />
          )}
        />
        <Controller
          name="taxIdType"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimRadioGroup
              field={field}
              fieldState={fieldState}
              options={[
                { value: 'SSN', label: 'SSN' },
                { value: 'EIN', label: 'EIN' },
              ]}
              row
            />
          )}
        />
      </Box>
    </>
  );
};